var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('micro-api-client'),
    JSONHTTPError = _require.JSONHTTPError,
    TextHTTPError = _require.TextHTTPError;

var omit = require('omit.js').default; // Read and parse the HTTP response


var parseResponse =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(response) {
    var responseType, textResponse, parsedResponse, ErrorType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            responseType = getResponseType(response);
            _context.next = 3;
            return response.text();

          case 3:
            textResponse = _context.sent;
            parsedResponse = parseJsonResponse(response, textResponse, responseType);

            if (response.ok) {
              _context.next = 8;
              break;
            }

            ErrorType = responseType === 'json' ? JSONHTTPError : TextHTTPError;
            throw new ErrorType(response, parsedResponse);

          case 8:
            return _context.abrupt("return", parsedResponse);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function parseResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getResponseType = function getResponseType(_ref2) {
  var headers = _ref2.headers;
  var contentType = headers.get('Content-Type');

  if (contentType != null && contentType.includes('json')) {
    return 'json';
  }

  return 'text';
};

var parseJsonResponse = function parseJsonResponse(response, textResponse, responseType) {
  if (responseType === 'text') {
    return textResponse;
  }

  try {
    return JSON.parse(textResponse);
  } catch (error) {
    throw new TextHTTPError(response, textResponse);
  }
};

var getFetchError = function getFetchError(error, url, opts) {
  var data = omit(opts, ['Authorization']);
  error.name = 'FetchError';
  error.url = url;
  error.data = data;
  return error;
};

module.exports = {
  parseResponse: parseResponse,
  getFetchError: getFetchError
};